import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  image: {
    borderRadius: '20px',
    boxShadow: '8px 8px 16px',
    objectFit: 'cover',
    maxWidth: '90%',
  },
}));
